import { api } from '../api';

/**
 * 管理者用：プロジェクトアクセス管理API
 */
const projectAccessApi = {
  /**
   * ユーザーにプロジェクトへのアクセス権を付与する
   * @param {string} userId ユーザーID
   * @param {string} projectId プロジェクトID
   * @returns {Promise} 結果
   */
  grantAccess: async (userId, projectId) => {
    const response = await api.post(`/admin/access/users/${userId}/projects/${projectId}`);
    return response.data;
  },

  /**
   * ユーザーからプロジェクトへのアクセス権を削除する
   * @param {string} userId ユーザーID
   * @param {string} projectId プロジェクトID
   * @returns {Promise} 結果
   */
  revokeAccess: async (userId, projectId) => {
    const response = await api.delete(`/admin/access/users/${userId}/projects/${projectId}`);
    return response.data;
  },

  /**
   * ユーザーのプロジェクトアクセス権一覧を取得する
   * @param {string} userId ユーザーID
   * @returns {Promise} プロジェクトアクセス権一覧
   */
  getUserProjects: async (userId) => {
    const response = await api.get(`/admin/access/users/${userId}/projects`);
    return response.data;
  },

  /**
   * プロジェクトにアクセスできるユーザー一覧を取得する
   * @param {string} projectId プロジェクトID
   * @returns {Promise} ユーザー一覧
   */
  getProjectUsers: async (projectId) => {
    const response = await api.get(`/admin/access/projects/${projectId}/users`);
    return response.data;
  },

  /**
   * 全ユーザー一覧を取得する
   * @returns {Promise} ユーザー一覧
   */
  getAllUsers: async () => {
    const response = await api.get(`/admin/access/users`);
    return response.data;
  },

  /**
   * 全プロジェクト一覧を取得する
   * @returns {Promise} プロジェクト一覧
   */
  getAllProjects: async () => {
    const response = await api.get(`/admin/access/projects`);
    return response.data;
  }
};

export default projectAccessApi;